// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3kaFh","footer":"ModalInfo_footer__lYL41"};